
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "env": "release",
  "buildInfo": {
    "version": "2.0.0-bridge.1",
    "time": 1788847603105,
    "commit": "6ef8f5129e6bc0953e18d28c7d8ae939e86a632d",
    "shortCommit": "6ef8f51",
    "branch": "release",
    "env": "release"
  },
  "una": {
    "primary": "yellow",
    "gray": "stone",
    "radius": 0.5,
    "fontSize": 16
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/runner/work/next.interviewroom.ai/next.interviewroom.ai/app/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
